import { useAnalyticsState } from "@/composables/state/analyticsState";
import useApplicationsState from "@/composables/state/applicationsState";
import { AnalyticsEvent } from "@/enums/analytics";
import type { FundingAdvisor } from "@/api/http/schemas/applicationSchemas";

export const useFundingAdvisorTracking = () => {
  const { selectedApplication } = useApplicationsState();
  const { trackEvent } = useAnalyticsState();

  const getEventProperties = (advisor: FundingAdvisor) => ({
    application_id: selectedApplication.value?.id ?? "",
    funding_advisor_name: [advisor.first_name, advisor.last_name].filter(Boolean).join(" "),
  });

  const trackCall = (advisor: FundingAdvisor) => {
    trackEvent(AnalyticsEvent.FundingAdvisorCalled, getEventProperties(advisor));
  };

  const trackCalendarOpened = (advisor: FundingAdvisor) => {
    trackEvent(AnalyticsEvent.FundingAdvisorCalendarOpened, getEventProperties(advisor));
  };

  return {
    trackCall,
    trackCalendarOpened,
  };
};
